import { useState, useCallback } from 'react'
import { Modal, Button, Icon } from '@dss/design-system'
import { SessionExpiredHandler, useAuth } from '@dss/auth'

/**
 * E7 — Session expired modal.
 *
 * Глобальный handler — рендерится в `__root.tsx`. Слушает события
 * `accessTokenExpired` / `userSignedOut` / `silentRenewError` через
 * <SessionExpiredHandler>. При срабатывании показывает forced re-login modal:
 * - НЕ закрывается ESC и backdrop click.
 * - Single CTA «Войти» → useAuth().login() (редирект на Keycloak).
 *
 * См. D09 §6 (UX foundations) и `@dss/auth/SessionExpiredHandler`.
 */
export function SessionExpiredModal() {
  const [open, setOpen] = useState(false)
  const { login } = useAuth()

  const handleSessionExpired = useCallback(() => {
    setOpen(true)
  }, [])

  const handleLoginClick = useCallback(() => {
    void login()
  }, [login])

  return (
    <>
      <SessionExpiredHandler onSessionExpired={handleSessionExpired} onSessionRestored={() => setOpen(false)} />
      <Modal
        open={open}
        // noop onClose: forced re-login, нельзя закрыть.
        onClose={() => {
          /* запрещено закрывать */
        }}
        closeOnOverlayClick={false}
        ariaLabel="Сессия истекла"
        width={440}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '8px 4px 4px' }}>
          <div
            aria-hidden="true"
            style={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              background: 'var(--color-warning-bg)',
              color: 'var(--color-warning-fg)',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 16,
            }}
          >
            <Icon name="Clock" size="xl" />
          </div>
          <h2
            style={{
              margin: '0 0 8px',
              fontSize: 20,
              fontWeight: 600,
              letterSpacing: '-0.01em',
              color: 'var(--color-text-primary)',
            }}
          >
            Сессия истекла
          </h2>
          <p
            style={{
              margin: '0 0 20px',
              fontSize: 14,
              color: 'var(--color-text-secondary)',
              lineHeight: 1.5,
            }}
          >
            Ваша сессия завершилась из-за неактивности. Войдите снова, чтобы продолжить.
          </p>
          <Button variant="primary" fullWidth onClick={handleLoginClick}>
            Войти
          </Button>
        </div>
      </Modal>
    </>
  )
}
